import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  checkAuth,
  checkEmpty,
  clearToken,
  getDateUtilYYYYTime,
  getDateUtilYYYYTimeNow,
  getToken,
  getUserMe,
  isAdmin,
  logoutApi,
  newDateUtil,
  parseJwt,
  pathRoutes,
} from "../service/util.service";

import $ from "jquery";

import styles from "./Menu.module.css";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "antd";
import { AppContext } from "../App.context";
import { menuAdmin, menuNotAdmin } from "./MenuTop";
const MenuLett = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  const warning = () => {
    Modal.warning({
      title: "Session",
      content: "Session หมดอายุ",
      afterClose: () => {
        appContext.setModalSession(false);
        logout();
      },
    });
  };

  const check = async () => {
    let data = await checkAuth();
    console.log("data : ", data);
    if (!data.status) {
      console.log("to login");
      // if (appContext.modalSession == false) {
      //   warning();
      //   appContext.setModalSession(true);
      // }
      logoutApi();
      clearToken();
      navigate(pathRoutes.login + "?session=false");
    }
  };
  const getusername = useMemo(() => {
    let user;
    try {
      user = parseJwt(getToken());
    } catch (e) {}
    let username = user?.username;
    return username;
  }, []);
  const logout = () => {
    logoutApi();
    clearToken();
    navigate(pathRoutes.login);
  };
  useEffect(() => {
    check();

    if (!checkEmpty(getToken())) {
      if (isAdmin()) {
        appContext.setMenuMain(menuAdmin);
      } else {
        appContext.setMenuMain(menuNotAdmin);
      }
    }
  }, []);

  useEffect(() => {
    $("#body").on("click", function () {
      // console.log("check session");
      let timealliveM = 1440;
      let currentDateStr = getDateUtilYYYYTimeNow();
      let currentDateUse = newDateUtil(currentDateStr);
      let sessionDateStr = localStorage.getItem("sessionDate");
      if (checkEmpty(sessionDateStr)) {
        localStorage.setItem("sessionDate", currentDateStr);
      } else {
        let sessionDateUse = newDateUtil(sessionDateStr);
        // sessionDateUse.setMinutes(sessionDateUse.getMinutes() + timealliveM);
        // console.log("sessionDateStr",sessionDateStr)
        // console.log("sessionDateUse",sessionDateUse)
        sessionDateUse.setMinutes(
          sessionDateUse.getMinutes() + parseInt(timealliveM)
        );
        // console.log("sessionDateUse:", sessionDateUse);
        // console.log("currentDateUse:", currentDateUse);
        if (sessionDateUse < currentDateUse) {
          localStorage.removeItem("sessionDate");
          logoutApi();
          clearToken();
          navigate(pathRoutes.login + "?session=false");
        } else {
          localStorage.setItem("sessionDate", currentDateStr);
        }
      }
    });
  }, []);

  let show = false;
  if (show)
    return (
      <div className={styles.boxMenu}>
        <div>username : {getusername}</div>
        {/* <div className={styles.btnLogout} onClick={logout}>logout</div> */}
        <div className={styles.btnLogout}>
          <Button danger onClick={logout}>
            Logout
          </Button>
        </div>
      </div>
    );
  else return <></>;
};

export default MenuLett;
